<template>
    <div class="wrapper">
        <b-form-group v-for="group in newRights" :key="group.name">
            <template slot="label">
                <b-form-checkbox v-model="group.selectAll"
                               :indeterminate="group.indeterminate"
                               @change="selectAll(group)"
                               :aria-describedby="'rights-' + group.name"
                               :aria-controls="'rights-' + group.name"
                >
                    {{ group.name }}
                </b-form-checkbox>
            </template>
            <b-form-checkbox-group :id="'rights-' + group.name"
                                 :name="'rights-' + group.name"
                                 stacked
                                 v-model="group.selected"
                                 :options="group.values"
                                 class="ml-4"
            />
        </b-form-group>
    </div>
</template>

<script>
import { Default } from '@/mixins/mixins';

export default {
    name: 'rightsList',
    mixins: [
        Default
    ],
    props: ['newRights', 'selectAll'],
    components: {
    },
    computed: {
    }
};
</script>

<style lang="scss" scoped>

</style>